import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-numeric-input',
  templateUrl: './numeric-input.component.html',
  styleUrls: ['./numeric-input.component.scss'],
})
export class NumericInputComponent implements OnInit {
  private initialValue: number;
  @Input() selectedValue: number;
  @Input() labelToDisplay: string;
  @Input() unit: string;
  @Input() minValue: number = 0;
  @Input() maxValue: number = Number.MAX_SAFE_INTEGER;
  @Input() placeholderToDisplay: string;
  @Input() step: number = 1;
  @Output() selectedValueChange = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {
    this.initialValue = this.selectedValue
      ? this.selectedValue
      : this.placeholderToDisplay
      ? null
      : 0;
    this.selectedValue = this.initialValue;
  }

  valueChange() {
    this.selectedValueChange.emit(this.selectedValue);
  }
}
